export default function wbsFilters() {
    const form = $('#wbs-filtering');
    const formLoader = $('.wbsLoader');

    form.submit(function (event) {
        event.preventDefault();

        const formData = form.serialize(); // Serializes the form data

        $.ajax({
            url: wbsMain.adminAjaxUrl,
            type: 'POST',
            data: formData + '&action=wbs_filter_rooms',
            beforeSend: function () {
                formLoader.removeClass('hidden');
            },
            success: function (response) {
                $('#rooms-list').html(response);
                formLoader.addClass('hidden');
                var calendars = $('.mphb-calendar.mphb-datepick');
                $.each(calendars, function (index, calendarEl) {
                    new MPHB.RoomTypeCalendar($(calendarEl));
                });
            },
            error: function (error) {
                console.error('Error:', error);
            }
        });
    });
};